export const sortByCoordinatesOnPDF = (
  a: { Json: string },
  b: { Json: string }
) => {
  const parsedA = JSON.parse(a.Json);
  const parsedB = JSON.parse(b.Json);

  if (parsedA?.lines?.length && parsedB?.lines?.length) {
    const pos_1 = parsedA.lines[0];
    const pos_2 = parsedB.lines[0];

    if (pos_1[1] !== pos_2[1]) {
      return pos_1[1] - pos_2[1];
    }

    // If Y coordinates are the same, compare X coordinates
    return pos_1[0] - pos_2[0];
  }
  return 0;
  // return pos_1[0] === pos_2[0] ? pos_1[1] - pos_2[1] : pos_1[0] - pos_2[0];
};
